export default {
  welcome: "Välkommen till Bwell!",
  welcomeBack: "Välkommen tillbaka när du ska uppdatera din Livsstilsplan!",
  pastPlansInfo: "",
  getStartedPrompt: "Klicka på knappen nedan för att komma igång!",
  reminderActivePlan: "Kom ihåg att göra färdigt din påbörjade livsstilsplan!",
  continue: "Fortsätt",
  latestPlan: "Min senaste livsstilsplan",
  showAllPlans: "Visa alla mina tidigare livsstilsplaner",
  hideOlderPlans: "Dölj tidigare livsstilsplaner",
  newPlanPrompt: "Är det dags för en ny livsstilsplan?",
  startFirstPlanPrompt: "Klicka på knappen nedan för att komma igång med din första livsstilsplan!",
  createNewPlan: "Skapa en ny livsstilsplan",
  getStarted: "Sätt igång",
  loading: "Laddar...",
  loadingPlan: "Hämtar plan...",
  errorHeader: "Åh nej!",
  errorMessage: "Ett fel uppstod när din plan skulle hämtas. Var vänlig prova igen.",
  okay: "Okej"
};
